
export interface MenuRoutes {
    path: string;
    text: string;
    children?:Array<MenuRoutes>
}
export const menuRoutes:Array<MenuRoutes> = [
		{
			path: "/",
			text: "Home"
		},
		{
			path: "/events/live",
			text: "Events",
            children:[
                {
                    path:"/events/create",
                    text:'Create Events'
                },
                {
                    path:"/events/live",
                    text:'Live Events'
                },                
                {
                    path:"/events/draft",
                    text:'Draft Events'
                },
                {
                    path:"/events",
                    text:'All Events'
                }                
            ]
		},
        {
			path: "/venue",
			text: "Venue",
            children:[               
                {
                    path:"/venue/create",
                    text:'Create Venue'
                },
                {
                    path:"/venue",
                    text:'All Venue'
                }
            ]
		},
        {
			path: "/artist",
			text: "Artist",
            children:[               
                {
                    path:"/artist/create",
                    text:'Create Artist'
                },
                {
                    path:"/artist",
                    text:'All Artists'
                }
            ]
		},
        {
			path: "/organiser",
			text: "Organiser",
            children:[               
                {
                    path:"/organiser/create",
                    text:'Create Organiser'
                },
                {
                    path:"/organiser",
                    text:'All Organiser'
                }                
            ]
		},
        
]